"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BomAutoReviewCompletedEvent = exports.BomItemAutoReviewedEvent = exports.BomItemResolvedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
const bom_resolution_enums_1 = require("./bom-resolution-enums");
exports.BomItemResolvedEvent = (0, event_1.createEventClass)('BomItemResolvedEvent', zod_1.z.object({
    projectModuleId: zod_1.z.string(),
    source: zod_1.z.nativeEnum(bom_resolution_enums_1.BomItemResolutionSource),
    identifierClass: zod_1.z.nativeEnum(bom_resolution_enums_1.BomItemIdentifierClass),
    outcome: zod_1.z.nativeEnum(bom_resolution_enums_1.BomItemResolutionOutcome),
    catalogue: zod_1.z.nativeEnum(bom_resolution_enums_1.BomItemResolutionCatalogue),
    packageId: zod_1.z.string().nullable(),
    sigmaModelId: zod_1.z.string().nullable(),
}));
exports.BomItemAutoReviewedEvent = (0, event_1.createEventClass)('BomItemAutoReviewedEvent', zod_1.z.object({
    bomItemId: zod_1.z.string(),
    referenceDesignator: zod_1.z.string().nullable(),
    resolutionType: zod_1.z.string().nullable(),
    sigmaModelType: zod_1.z.string().nullable(),
    outcome: zod_1.z.nativeEnum(bom_resolution_enums_1.AutoReviewOutcome),
    rejectionReason: zod_1.z.nativeEnum(bom_resolution_enums_1.AutoReviewRejectionReason).optional(),
}));
exports.BomAutoReviewCompletedEvent = (0, event_1.createEventClass)('BomAutoReviewCompletedEvent', zod_1.z.object({
    projectModelId: zod_1.z.string().nullable(),
    totalCount: zod_1.z.number(),
    newlyReviewedCount: zod_1.z.number(),
    alreadyReviewedCount: zod_1.z.number(),
    remainsUnreviewedCount: zod_1.z.number(),
    rejectedPackageDraftCount: zod_1.z.number(),
    rejectedNoValidatorCount: zod_1.z.number(),
    rejectedParameterMissingCount: zod_1.z.number(),
    rejectedParameterOutOfRangeCount: zod_1.z.number(),
    rejectedSignalsNotMappedCount: zod_1.z.number(),
    rejectedOtherCount: zod_1.z.number(),
}));
//# sourceMappingURL=bom-resolution-events.js.map